import { CommonEventProperties, SelfDescribingEvent } from '@snowplow/browser-tracker';
import { PlayContext } from '@genially/snowplow-contracts';

import { mapAllContextsAsArray } from './../utils/mapAllContextsAsArray';

export const getPlayPlayerSessionJoinedEvent = ({
  play,
  place,
}: {
  play: PlayContext;
  place: 'lobby' | 'in-game';
}): SelfDescribingEvent & CommonEventProperties => ({
  event: {
    schema: 'iglu:com.genially/play_session_joined/jsonschema/1-0-0',
    data: {},
  },
  context: mapAllContextsAsArray({
    play,
    trigger: place,
  }),
});
